export function isElsterFoundationEnabled() {
  return (
    process.env['ENABLE_ELSTER_FOUNDATION'] === 'true' ||
    process.env['NEXT_PUBLIC_ENABLE_ELSTER_FOUNDATION'] === 'true'
  );
}

export function isDatevFoundationEnabled() {
  return (
    process.env['ENABLE_DATEV_FOUNDATION'] === 'true' ||
    process.env['NEXT_PUBLIC_ENABLE_DATEV_FOUNDATION'] === 'true'
  );
}

export function isKdpFoundationEnabled() {
  return (
    process.env['ENABLE_KDP_FOUNDATION'] === 'true' ||
    process.env['NEXT_PUBLIC_ENABLE_KDP_FOUNDATION'] === 'true'
  );
}
